<div class="sharesHeaders__exports" ppTooltip [ppTitle]="ppDisabled ? disabledTooltipText : ''">
  <pp-toggle
    [ppDisabled]="ppDisabled"
    [ppChecked]="viewPermission"
    (ppAction)="changeViewPermission()"
    ppStyle="blue"
  ></pp-toggle>
</div>
